export default "/assets/webshop/img/kariban.jpg?4a509a696e17b5d81f6c741aaa8919ea";